(<template>
  <article class="confirmed-email">
    <div class="confirmed-email__icon"></div>
    <h3 class="confirmed-email__subtitle">{{ $gettext('Email verified') }}</h3>
    <p class="confirmed-email__description">{{ $gettext('Your email address has been successfully verified. You can now proceed with using all features of your account.') }}</p>
    <button class="sk-btn sk-btn--default confirmed-email__btn"
            @click="confirmVerification">{{ $gettext('Continue') }}</button>
  </article>
</template>)

<script>
  export default {
    methods: {
      confirmVerification() {
        this.$store.dispatch('sendVerificationEmailShown').then(() => {
          this.$store.dispatch('UserInfoStore/fetchUserInfo', this.$store.getters['UserInfoStore/userUid']).then(() => {
            this.$store.dispatch('ModalStore/closeModal');
          });
        });
      }
    }
  };
</script>

<style scoped>
  .confirmed-email {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: -15px;
    padding: 0 30px 30px;
    background-color: #fff;
    text-align: center;
  }

  .confirmed-email__icon {
    width: 48px;
    height: 48px;
    margin-right: auto;
    border-radius: 50%;
    background-color: var(--color-success-100);
    background-image: url(~@assets/imgs/undefined_imgs/success_icon_big.svg);
    background-position: center center;
    background-size: auto 24px;
    background-repeat: no-repeat;
  }

  .confirmed-email__subtitle {
    margin: 24px auto 16px 0;
    color: var(--black-700);
    font-size: 20px;
  }

  .confirmed-email__description {
    color: var(--black-700);
    text-align: left;
  }

  .confirmed-email__btn {
    width: auto;
    margin: 24px 0 0 auto;
    padding: 0 12px;
  }
</style>
